import React from "react";
import { IconCheck, IconRefresh } from "@tabler/icons-react";

type Props = {
    imageSrc: string;
    isBusy: boolean;
    busyLabel?: string;
    onRetake: () => void;
    onConfirm: () => void;
};

const VoterPhotoPreviewStep = ({
    imageSrc,
    isBusy,
    busyLabel = "Saving...",
    onRetake,
    onConfirm,
}: Props) => (
    <>
        <div className="mx-auto aspect-[4/3] w-full max-w-xl overflow-hidden rounded-xl bg-gray-100">
            <img src={imageSrc} alt="Voter preview" className="h-full w-full object-contain" />
        </div>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
            <button
                type="button"
                onClick={onRetake}
                disabled={isBusy}
                className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            >
                <IconRefresh size={18} />
                Retake
            </button>
            <button
                type="button"
                onClick={onConfirm}
                disabled={isBusy}
                className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-green-700 disabled:opacity-60"
            >
                <IconCheck size={18} />
                {isBusy ? busyLabel : "Save Photo"}
            </button>
        </div>
    </>
);

export default VoterPhotoPreviewStep;
